import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Facebook, Instagram, Mail } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const { organization } = mockData;

  return (
    <footer className="bg-darkslate-600 text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Organization Info */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center">
                <Heart className="h-6 w-6 text-white fill-white" />
              </div>
              <span className="text-lg font-bold">
                Kibbles & Bits of Kindness
              </span>
            </div>
            <p className="text-mauve-300 text-sm">
              Keeping pets with their loving families in {organization.location}.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4 text-amber-400">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-mauve-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-mauve-300 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-mauve-300 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-mauve-300 hover:text-white transition-colors">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h3 className="font-semibold mb-4 text-amber-400">Get Involved</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/volunteer" className="text-mauve-300 hover:text-white transition-colors">
                  Volunteer
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-mauve-300 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <a 
                  href={`mailto:${organization.emails.donations}`} 
                  className="text-mauve-300 hover:text-white transition-colors"
                >
                  Make a Donation
                </a>
              </li>
              <li>
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSeOVODJjWPU2frnYvpHIOt_8DbiqrVXICIQreiph4ZnKdNh4Q/viewform?usp=header"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-mauve-300 hover:text-white transition-colors"
                  data-testid="footer-get-help-link"
                >
                  Get Help
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="font-semibold mb-4 text-amber-400">Connect With Us</h3>
            <div className="flex gap-3 mb-4">
              <a
                href={organization.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-darkslate-700 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={organization.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-darkslate-700 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={`mailto:${organization.emails.general}`}
                className="w-10 h-10 bg-darkslate-700 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
            <p className="text-mauve-300 text-sm">
              Follow us on social media for updates and success stories!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-darkslate-500 mt-8 pt-8 text-center text-sm text-mauve-300">
          <p>
            © {new Date().getFullYear()} {organization.name}. All rights reserved.
          </p>
          <p className="mt-2">
            Serving {organization.serviceArea} with compassion and dedication.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
